import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, ExternalLink, Home, Calendar, Hash } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatOrderNumber } from '../utils/orderNumber';
export function ThankYouPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderCopied, setOrderCopied] = useState(false);
  const name = searchParams.get('name') || 'חבר';
  const email = searchParams.get('email') || '';
  const orderNumber = searchParams.get('orderNumber') || '';
  const handleCopyOrderNumber = () => {
    navigator.clipboard.writeText(orderNumber);
    setOrderCopied(true);
    setTimeout(() => setOrderCopied(false), 2000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white" dir="rtl" data-id="element-1903" data-mp="3msvz67fa7sav">
      <Navigation data-id="element-1904" data-mp="3rrgx20729zw5" />

      <div className="container mx-auto px-4 py-20" data-id="element-1905" data-mp="3rss2s5k2hhpw">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-1906" data-mp="3rpcjeqjd1mio">
          {/* Success Icon */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="flex justify-center mb-8" data-id="element-1907" data-mp="eckd25ceeq98">
            <div className="bg-green-100 rounded-full p-6" data-id="element-1908" data-mp="2l4lge14xch9j">
              <CheckCircle className="w-20 h-20 text-green-600" data-id="element-1909" data-mp="2p4lsvg8gqidy" />
            </div>
          </motion.div>

          {/* Thank You Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-center mb-12" data-id="element-1910" data-mp="3sgkjvx68luxr">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-1911" data-mp="186nr2l7wauu">
              תודה {name}! 🎉
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-1912" data-mp="f6wocs78wsny">
              ההרשמה שלך ל-Water Tribe Fest 2026 התקבלה בהצלחה!
            </p>
            <p className="text-lg text-gray-500 mt-2" data-id="element-1913" data-mp="oy10zl9g81fm">
              קיבלת אישור למייל: <span className="font-semibold" data-id="element-1914" data-mp="jzfytgamz7oj">{email}</span>
            </p>
          </motion.div>

          {/* Order Number Card */}
          {orderNumber && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-indigo-200 mb-8" data-id="element-1915" data-mp="xxo54etkblcd">
              <div className="flex items-center gap-3 mb-4" data-id="element-1916" data-mp="13nu7stcgpqgw">
                <div className="bg-indigo-100 rounded-full p-2" data-id="element-1917" data-mp="17mbjzraqpr56">
                  <Hash className="w-6 h-6 text-indigo-600" data-id="element-1918" data-mp="tw80h838wbjf" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-1919" data-mp="tu5508jbpq7b">
                  מספר הזמנה
                </h2>
              </div>

              <p className="text-gray-600 mb-4" data-id="element-1920" data-mp="jytktap5bqs6">
                זהו מספר ההזמנה הייחודי שלך. שמור אותו לצורך התכתבות ואימות
                בכניסה לאירוע.
              </p>

              <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-6 border-2 border-indigo-100" data-id="element-1921" data-mp="awkcmrhco9hy">
                <div className="flex items-center justify-between gap-4" data-id="element-1922" data-mp="fv5eswg5x391">
                  <div className="flex-1" data-id="element-1923" data-mp="7w0pkdm2lwbj">
                    <p className="text-sm text-gray-600 mb-2" data-id="element-1924" data-mp="7uzewa8yvbuc">
                      מספר ההזמנה שלך:
                    </p>
                    <p className="text-3xl md:text-4xl font-black text-indigo-600 tracking-wider" data-id="element-1925" data-mp="2yqscbsfwgd5">
                      {orderNumber}
                    </p>
                  </div>
                  <button onClick={handleCopyOrderNumber} className="bg-indigo-100 hover:bg-indigo-200 p-4 rounded-xl transition-colors shrink-0" data-id="element-1926" data-mp="3q98blx0sec64">
                    {orderCopied ? <CheckCircle className="w-6 h-6 text-indigo-600" data-id="element-1927" data-mp="3bbo9cxv9yv3n" /> : <Copy className="w-6 h-6 text-indigo-600" data-id="element-1928" data-mp="37b4czwiizvik" />}
                  </button>
                </div>
              </div>
            </motion.div>}

          {/* Billing Announcement */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55
        }} className="bg-amber-50 rounded-2xl p-6 md:p-8 shadow-lg border-2 border-amber-300 mb-8" data-id="element-1929" data-mp="15kkkop2777ck">
            <div className="flex items-start gap-4" data-id="element-1930" data-mp="318sotwbxp0yr">
              <div className="bg-amber-200 rounded-full p-3 shrink-0 mt-0.5" data-id="element-1931" data-mp="317hqic19clf1">
                <span className="text-2xl" data-id="element-1932" data-mp="24jbkplslnmz6">⚠️</span>
              </div>
              <div data-id="element-1933" data-mp="29gbil9fapjf7">
                <h3 className="text-xl md:text-2xl font-black text-amber-900 mb-2" data-id="element-1934" data-mp="29hwcqxxp70cj">
                  שימו לב! ❤️
                </h3>
                <p className="text-lg font-semibold text-amber-800 leading-relaxed" data-id="element-1935" data-mp="2dksygxijbckp">
                  החיוב יופיע מחברת{' '}
                  <span className="font-black text-amber-950" data-id="element-1936" data-mp="3oy3spmokzbh4">
                    "אנרצ'י רפואה משלימה"
                  </span>
                  , סכום החיוב יהיה זהה לסכום ההזמנה.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Next Steps */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-8" data-id="element-1937" data-mp="1pt3q7k2q8ra7">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1938" data-mp="1b4qxcvyxrojx">מה הלאה?</h3>
            <div className="space-y-4" data-id="element-1939" data-mp="1665vyt7y6ytw">
              <div className="flex items-start gap-4" data-id="element-1940" data-mp="1639uiuww5s0p">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-1941" data-mp="1kv27x1d4kvzs">
                  <CheckCircle className="w-5 h-5 text-[#0A5F8F]" data-id="element-1942" data-mp="1g2scx6x5l5qn" />
                </div>
                <div data-id="element-1943" data-mp="sdg6get7nbs1">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-1944" data-mp="scxzoo8x9f5v">אישור במייל</h4>
                  <p className="text-gray-600" data-id="element-1945" data-mp="newgm3bhxfue">
                    קיבלת אישור הרשמה למייל עם כל הפרטים החשובים
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-1946" data-mp="2z05fi44faojp">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-1947" data-mp="33tqcpty6zehu">
                  <CheckCircle className="w-5 h-5 text-[#0A5F8F]" data-id="element-1948" data-mp="2q1tr88r142uf" />
                </div>
                <div data-id="element-1949" data-mp="2u2m1947q6brr">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-1950" data-mp="2u23z5qydt3bx">
                    הצטרף לקבוצת הווטסאפ
                  </h4>
                  <p className="text-gray-600 mb-2" data-id="element-1951" data-mp="3hszj61wliu8m">
                    הצטרף לקבוצת הווטסאפ השקטה של הפסטיבל לעדכונים
                  </p>
                  <a href="https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA" target="_blank" rel="noopener noreferrer" className="text-[#0A5F8F] hover:underline font-semibold inline-flex items-center gap-2" data-id="element-1952" data-mp="38rrvsevmbdtb">
                    לחץ כאן להצטרפות
                    <ExternalLink className="w-4 h-4" data-id="element-1953" data-mp="22ch7iey2scdv" />
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-1954" data-mp="2t343o0de5jyy">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-1955" data-mp="2ozxykw20lyu2">
                  <Calendar className="w-5 h-5 text-[#0A5F8F]" data-id="element-1956" data-mp="2k13775pzf1yc" />
                </div>
                <div data-id="element-1957" data-mp="2k2xrqixccs1w">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-1958" data-mp="2f29rr7r4x0vj">סמן ביומן</h4>
                  <p className="text-gray-600" data-id="element-1959" data-mp="2f4csomttsef1">
                    19-21 בנובמבר 2026 | חוף מעגן עדן, כנרת
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Back to Home Button */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-center" data-id="element-1960" data-mp="32yxbj6g60pae">
            <Button onClick={() => navigate('/water-tribe-fest')} variant="outline" className="inline-flex items-center gap-2" data-id="element-1961" data-mp="3qptb4pqv4os7">
              <Home className="w-5 h-5" data-id="element-1962" data-mp="1xoaqc9f3o0q" />
              חזרה לדף הפסטיבל
            </Button>
          </motion.div>
        </motion.div>
      </div>

      <Footer data-id="element-1963" data-mp="bsg6dajfw0sv" />
    </div>;
}